import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import VerificationPending from "../pages/VerificationPending";
import { GetRouterBasename } from "../utils/verifSubdomain";

export default function VerificationRoutes() {
    const basename = GetRouterBasename()

    return (
        <BrowserRouter basename={basename}>
            <Routes>
                <Route path="*" element={<VerificationPending />} />
            </Routes>
        </BrowserRouter>
    )
}
